import React, { useState, useEffect } from 'react';
import { Loader2, Mail, MapPin, Phone } from 'lucide-react';
import Layout from '../Layout';
import { getData, postData } from '../../helpers/ApiSettings';
import SocialMediaLinks from '../SocialMediaLinks';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    acceptance: false
  });
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const response = await getData('/company-info?populate=*');
        // console.log(response.data.data)
        setCompanyInfo(response.data.data);
      } catch (error) {
        console.error('Error fetching company info:', error);
      }
    };

    fetchCompanyInfo();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus('');

    try {
      await postData('/contact-messages', {
        data: formData
      });
      setStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '', acceptance: false });
    } catch (error) {
      setStatus('error');
      console.error('Error sending message:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  return (
    <Layout>
      <div className="bg-light py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h1 className="display-4 fw-bold">Contactez-nous</h1>
            <p className="lead text-muted mb-0">
              Une question ? N'hésitez pas à nous contacter !
            </p>
          </div>

          <div className="row g-4">
            {/* Contact Information */}
            <div className="col-md-6">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <h2 className="card-title h4">Nos Coordonnées</h2>

                  <div className="mb-4">
                    {/* <div className="d-flex align-items-start mb-3">
                      <MapPin className="text-primary me-3" size={24} />
                      <div>
                        <p className="mb-0">
                          {companyInfo?.address || '123 Rue Example'}
                          <br />
                          {companyInfo?.city || '75000 Paris'}
                        </p>
                      </div>
                    </div> */}

                    <div className="d-flex align-items-center mb-3">
                      <Phone className="text-primary me-3" size={24} />
                      <p className="mb-0">
                        {companyInfo?.phone || '01 23 45 67 89'}
                      </p>
                    </div>

                    <div className="d-flex align-items-center mb-3">
                      <Mail className="text-primary me-3" size={24} />
                      <p className="mb-0">
                        {companyInfo?.email || 'contact@ovlm97.fr'}
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 className="h5">Horaires d'ouverture</h3>
                    <div>
                      {companyInfo?.opening_hours ? (
                        <div dangerouslySetInnerHTML={{
                          __html: companyInfo.opening_hours.replace(/\n/g, '<br />')
                        }} />
                      ) : (
                        <>
                          <p>Lundi - Vendredi: 9h00 - 18h00<br />
                          Samedi: 10h00 - 16h00<br />
                          Dimanche: uniquement par WhatsApp en cas d'urgence 📱</p>
                        </>
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="text-center mt-4">
                      <SocialMediaLinks socialMedia={companyInfo?.socialmedia || []} mode="light" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-md-6">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <h2 className="card-title h4">Envoyez-nous un message</h2>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">Nom complet</label>
                      <input
                        type="text"
                        name="name"
                        id="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">Email</label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="subject" className="form-label">Sujet</label>
                      <input
                        type="text"
                        name="subject"
                        id="subject"
                        required
                        value={formData.subject}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="message" className="form-label">Message</label>
                      <textarea
                        name="message"
                        id="message"
                        rows={4}
                        required
                        value={formData.message}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>

                    <div className="form-check mb-3">
                      <input
                        type="checkbox"
                        name="acceptance"
                        id="acceptance"
                        rows={4}
                        required
                        onChange={handleChange}
                        className="form-check-input"
                        checked={formData.acceptance}
                      />
                      <label htmlFor="acceptance" className="form-check-label">
                        J'accepte les <a href="/page/cgv" target="_blank">Conditions Générales</a>
                      </label>
                    </div>

                    <button
                      type="submit"
                      disabled={isLoading}
                      className="btn btn-primary w-100"
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Envoi en cours...
                        </>
                      ) : (
                        'Envoyer le message'
                      )}
                    </button>

                    {status === 'success' && (
                      <div className="alert alert-success mt-3 mb-0">
                        Message envoyé avec succès !
                      </div>
                    )}

                    {status === 'error' && (
                      <div className="alert alert-danger mt-3 mb-0">
                        Une erreur est survenue. Veuillez réessayer.
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContactPage;